import { Component } from "react";
import Button from "../../../utilities/Button";
import FontAwesome from "../../../utilities/FontAwesome";
import { observer } from "mobx-react";
import classNames from "classnames";
import styles from "./styles/LocationBlockItem.module.scss";
import { StoreContext } from "../../../../stores/StoreContext";
import dynamic from "next/dynamic";
import ImageComponent from "../../../utilities/ImageComponent";

const PhoneNumber = dynamic(() => import("../../../utilities/PhoneNumber"));

interface ILocationBlockItemProps {
  location: {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string | number;
    phone?: string | number;
    hours?: any;
    organization?: any;
  };
  onClick?: () => void;
  className?: string;
  attribution?: string;
}

@observer
class LocationBlockItem extends Component<ILocationBlockItemProps> {
  static contextType = StoreContext;
  declare context: React.ContextType<typeof StoreContext>;

  render() {
    const mapInsertClassName = classNames({
      [styles.mapInsert]: true,
      [this.props.className as string]: this.props.className,
    });
    const insertSectionClassName = classNames({
      [styles.insertSection]: true,
      ["notranslate"]: true,
    });

    let addressText = this.props.location.address;
    if (this.props.location.address2) {
      addressText += ` ${this.props.location.address2}`;
    }
    if (this.props.location.city) {
      addressText += ` ${this.props.location.city}`;
    }
    if (this.props.location.state) {
      addressText += `, ${this.props.location.state}`;
    }
    if (this.props.location.zip) {
      addressText += ` ${this.props.location.zip}`;
    }

    let phone: React.ReactNode = "";
    if (this.props.location && this.props.location.phone) {
      phone = (
        <>
          <FontAwesome prefix={"fas"} name={"fa-phone-alt"} />
          <PhoneNumber number={this.props.location.phone} isLinked={true} />
        </>
      );
    }

    return (
      <div className={mapInsertClassName}>
        {this.props.onClick && (
          <Button onClick={this.props.onClick} aria-label={"Close Map Insert"}>
            <FontAwesome ariaHidden={true} prefix={"fas"} name={"fa-times"} />
          </Button>
        )}
        <div>
          <ImageComponent
            src={this.props.location.organization.logo}
            alt={`${this.props.location.organization.title} logo`}
            title={this.props.location.organization.title}
          />
        </div>
        {addressText && (
          <div className={insertSectionClassName}>
            <FontAwesome prefix="fas" name={"fa-map-marker-alt"} />
            <address>{addressText}</address>
          </div>
        )}
        {phone && <div className={insertSectionClassName}>{phone}</div>}
      </div>
    );
  }
}

export default LocationBlockItem;
